/* Progressive enhancement only: article content remains readable without JS. */
(() => {
  const normalize = text => text.normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  function init(root) {
    if (root.dataset.storyReady) return;
    root.dataset.storyReady = 'true';
    const body = root.querySelector('[data-story-body]');
    if (!body) return;
    // Imported CMS layouts include their own global CSS. The theme owns typography.
    body.querySelectorAll('style').forEach(style => style.remove());
    if (root.querySelector('[data-story-products] .wfs-editorial-product')) {
      body.querySelectorAll('.wfs-ad').forEach(ad => {
        if (ad.querySelector('a[href*="/products/"]')) ad.remove();
      });
      // Older advertorials have inline styles instead of a named ad component.
      body.querySelectorAll('a[href*="/products/"]').forEach(link => {
        if (!/kup teraz|kupuję|shop now|buy now/i.test(link.textContent)) return;
        let parent = link.parentElement;
        while (parent && parent !== body && !parent.classList.contains('wfs-article')) {
          if (parent.querySelector('img') && parent.querySelector('h2,h3')) {
            parent.remove();
            break;
          }
          parent = parent.parentElement;
        }
      });
    }
    const title = normalize(root.dataset.title || '');
    const initialHeading = body.querySelector('h1');
    if (initialHeading) {
      const text = normalize(initialHeading.textContent);
      if (text && (title === text || title.startsWith(text))) initialHeading.remove();
    }
    body.querySelectorAll('h1').forEach(heading => {
      const replacement = document.createElement('h2');
      replacement.innerHTML = heading.innerHTML;
      if (heading.id) replacement.id = heading.id;
      heading.replaceWith(replacement);
    });
    // Remove only presentation overrides, retaining emphasis, links and media layout.
    body.querySelectorAll('p,li,span,h2,h3,h4').forEach(el => {
      ['font-family','font-size','line-height','color','text-align','letter-spacing'].forEach(prop => el.style.removeProperty(prop));
    });
    const lead = root.querySelector('[data-story-lead]');
    const first = body.querySelector('p');
    const balancedQuote = !first || (first.textContent.match(/"/g) || []).length % 2 === 0;
    if (lead && first && balancedQuote && !first.querySelector('img,iframe,video') && first.textContent.trim().length > 30 && first.textContent.trim().length <= 500) {
      if (!lead.textContent.trim()) {
        lead.textContent = first.textContent.trim();
        lead.hidden = false;
        first.remove();
      } else if (normalize(first.textContent) === normalize(lead.textContent)) first.remove();
    }
    body.querySelectorAll('p').forEach(p => {
      if (!p.textContent.trim() && p.querySelector('img') && !p.closest('.wfs-gallery')) p.classList.add('wfs-story__media');
      if (!p.textContent.trim() && !p.querySelector('img,iframe,video,audio,br')) p.remove();
    });
    body.querySelectorAll('.wfs-image,.wfs-gallery').forEach(el => el.classList.add('wfs-story__media'));
    body.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; });
    body.querySelectorAll('iframe').forEach(frame => { frame.loading = 'lazy'; if (!frame.title) frame.title = root.dataset.title; });
    const textClone = body.cloneNode(true);
    textClone.querySelectorAll('script,style,iframe').forEach(el => el.remove());
    const words = ((lead?.textContent || '') + ' ' + textClone.textContent).trim().split(/\s+/).filter(Boolean).length;
    const time = root.querySelector('[data-story-time]');
    if (time) time.textContent = root.dataset.minutesTemplate.replace('COUNT', Math.max(1, Math.ceil(words / 200)));
    const toc = root.querySelector('[data-story-toc]');
    const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
    if (toc && headings.length >= 3 && words >= 600) {
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'story-section-' + (index + 1);
        const li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent.trim();
        li.append(a); list.append(li);
      });
      toc.hidden = false;
    }
    root.querySelector('[data-story-share]')?.addEventListener('click', async event => {
      const button = event.currentTarget, status = root.querySelector('[data-share-status]');
      const url = document.querySelector('link[rel="canonical"]')?.href || location.origin + location.pathname;
      try {
        if (navigator.share) await navigator.share({title: root.dataset.title, url});
        else {
          await navigator.clipboard.writeText(url);
          status.textContent = button.dataset.copied;
          const label = button.textContent;
          button.textContent = button.dataset.copied;
          window.setTimeout(() => { button.textContent = label; }, 3000);
        }
      } catch (error) {
        if (error.name !== 'AbortError') status.textContent = button.dataset.failed;
      }
    });
    const openComments = () => {
      if (/^#(?:comments|Comment|comment)/.test(location.hash)) {
        const details = root.querySelector('.wfs-story__comments');
        if (details) details.open = true;
      }
    };
    openComments(); window.addEventListener('hashchange', openComments);
  }
  const start = scope => scope.querySelectorAll('[data-wfs-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), {once:true});
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
